angular.module('GlobalHelpersModule').filter "showRace", ->
  (races) ->
    if races == ""
      'Provider did not ask'
    else
      raceNames = _.map races, "raceName"
      raceNames.join(", ")